var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGnt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#001D57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.499 5.288l1.203 1.204-2.277 2.34c.48.73.738 1.591.738 2.479a4.448 4.448 0 01-1.258 3.131 4.183 4.183 0 01-2.217 1.226v2.039a4.273 4.273 0 012.213 1.22 4.451 4.451 0 011.262 3.136 4.451 4.451 0 01-1.262 3.135 4.262 4.262 0 01-3.07 1.302 4.24 4.24 0 01-3.07-1.302 4.474 4.474 0 01-1.261-3.135c0-1.18.448-2.299 1.258-3.132a4.183 4.183 0 012.217-1.225v-2.04a4.274 4.274 0 01-2.213-1.22A4.474 4.474 0 0111.5 11.31c0-1.18.448-2.299 1.262-3.135a4.262 4.262 0 013.07-1.303c.86 0 1.687.262 2.395.749L20.5 5.288zm-4.667 14.057a2.53 2.53 0 00-1.857.79 2.751 2.751 0 00-.775 1.928c0 .725.275 1.402.775 1.927a2.58 2.58 0 001.857.79 2.53 2.53 0 001.856-.79 2.751 2.751 0 00.775-1.927c0-.725-.275-1.402-.778-1.931a2.527 2.527 0 00-1.853-.787zm1.853-6.09a2.754 2.754 0 00.778-1.931 2.7 2.7 0 00-.775-1.928 2.578 2.578 0 00-1.856-.79 2.53 2.53 0 00-1.857.79 2.751 2.751 0 00-.775 1.928c0 .725.275 1.402.775 1.927a2.58 2.58 0 001.857.79c.711 0 1.367-.276 1.853-.786z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnt);
export default __webpack_public_path__ + "static/media/gnt.09af7cc35a58631328a95dec12655ca6.svg";
export { ForwardRef as ReactComponent };